import * as actions from './actionTypes';

export const clearedData = (type, fieldName) => ({
  type: actions.clearedData,
  payload: {
    type: type,
    fieldName: fieldName,
  },
});

export const selectedService = (service) => ({
  type: actions.selectedService,
  payload: service,
});

export const selectedCity = (city) => ({
  type: actions.selectedCity,
  payload: city,
});

export const selectedAge = (age) => ({
  type: actions.selectedAge,
  payload: age,
});

export const selectedRobot = (robot) => ({
  type: actions.selectedRobot,
  payload: robot,
});

export const selectedLocation = (location) => ({
  type: actions.selectedLocation,
  payload: location,
});

export const selectedOccurrence = (occurrence) => ({
  type: actions.selectedOccurrence,
  payload: occurrence,
});

// export const clickedNextButton = (page) => ({
//   type: actions.clickedNextButton,
//   payload: page
// })

// export const clickedBackButton = (page) => ({
//   type: actions.clickedBackButton,
//   payload: page
// })

export const loadedPage = (page) => ({
  type: actions.loadedPage,
  payload: page,
});

export const changedMapFilter = (id) => ({
  type: actions.changedMapFilter,
  payload: id,
});

export const changedAgreement = (agreement) => ({
  type: actions.changedAgreement,
  payload: agreement,
});

// export const suggestedPlace = () => ({
//   type: actions.suggestedPlace,
//   payload: null
// })

export const sentForm = (type) => ({
  type: actions.sentForm,
  payload: type,
});

export const changedContactForm = ({ field, text, valid }) => ({
  type: actions.changedContactForm,
  payload: { field, text, valid },
});

export const changedKnownClient = ({ field, text, value, valid }) => ({
  type: actions.changedKnownClient,
  payload: { field, text, value, valid },
});

export const downloadedData = (data, type) => ({
  type: actions.downloadedData,
  payload: {
    type: type,
    data: data,
  },
});

export const changedMapPosition = (field, value) => ({
  type: actions.changedMapPosition,
  payload: {
    field: field,
    value: value,
  },
});

export const closedTip = (name) => ({
  type: actions.closedTip,
  payload: name,
});
